import Redirects from './Redirects'

export default Redirects